import { defineComponent as _defineComponent } from 'vue'

  import Modal from "@/components/ui/Modal.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'TransitionModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    attentionType: {
      required: true,
      type: String,
    },
    lot: {
      type: Object,
    },
  },
  emits: ["close", "proceed"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  function close() {
    emits("close");
  }
  function proceed() {
    emits("proceed");
  }

const __returned__ = { emits, props, close, proceed, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})